<template>
<!-- 常见问题-无设备 -->
    <div class="noEquipment">
        <p>设备管理中无设备信息</p>
        <!-- <p>问题描述：</p> -->
        <p style="text-indent: 18px;">扫描JJM-DZ型，或JJM-V型二维码,配网后能搜索到设备,没有绑定过程。直接进入到了微信公众号内。在公众号--设备管理--设备使用及统计详情--没有发现设备</p>
        <p>解决方案：</p>
        <p>1、查看微信本身：我--设置--设备--电子气动护眼仪JJM-DZ型，或JJM-V型--点击--删除设备</p>
        <p>2、重新扫描二维码，配网绑定</p>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style>
body{
    background: #f8f8f8f8;
}
p {
    margin: 0;
    padding: 0;
}
.noEquipment {
    background: #ffffff;
    border-radius: 25px;
    padding: 28px;
    margin: 28px;
    font-size: 40px;
    letter-spacing: 5px;
    color: #333333;
    
}

.noEquipment p {
    line-height: 60px;
}

.noEquipment p:first-of-type {
    text-align: center;
    font-weight: 600;
    margin-bottom: 56px;
}

.noEquipment p:nth-of-type(2) {
    margin-bottom: 72px;
}

.noEquipment img {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/NoEquipment.vue